import { GenericService } from 'services/genericService';
import { createOfflinePayment, downloadOfflinePaymentsAttachments } from 'utils/api/queries/microApi';
import { Observable } from 'rxjs';
import { getOfflinePayments } from 'utils/api/queries/microApi';
import { OfflinePayments } from 'utils/api/models/billingPaymentTrack/offlinePayments';
import { finalize } from 'rxjs/operators';
import invalidateCache from 'utils/api/invalidateCache';
import { getBanks } from 'utils/api/queries/wcm';
import { BankItems } from 'utils/api/models/billingPaymentTrack/bankItems';
import { OfflinePaymentCreate } from 'utils/api/models/billingPaymentTrack/offlinePaymentCreate';

export class BillingPaymentTrackService extends GenericService {
	public static createOfflinePayment(data: any): Observable<OfflinePaymentCreate> {
		return createOfflinePayment(data)
			.disableCache()
			.call()
			.pipe(finalize(() => invalidateCache(['getOfflinePayments'], true)));
	}

	public static downloadAttachment(attachmentId: number): Observable<any> {
		return downloadOfflinePaymentsAttachments(attachmentId).call();
	}

	public static getOfflinePayments(upId: string | null): Observable<OfflinePayments> {
		return getOfflinePayments(upId)
			.withErrorHandling()
			.setInvalidateKey('getOfflinePayments')
			.call();
	}

	public static getBanks(language: string): Observable<BankItems> {
		return getBanks(language)
			.withErrorHandling()
			.call();
	}
}
